import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { KeycloakService } from 'keycloak-angular';
import { provideAnimations } from '@angular/platform-browser/animations';
import { environment } from 'projects/admin/src/environments/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from 'projects/core/src/lib/interceptors/auth/auth.interceptor';
import { loadingInterceptor } from 'projects/core/src/lib/interceptors/loading/loading.interceptor';
import { MessageService } from 'primeng/api';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

function initializeKeycloak(keycloak: KeycloakService) {
    return () =>
        keycloak.init({
            config: {
                realm: environment.keycloakConfig.realm,
                url: environment.keycloakConfig.url,
                clientId: environment.keycloakConfig.clientId,
            },
            initOptions: {
                onLoad: 'check-sso',
                checkLoginIframe: false,
                silentCheckSsoRedirectUri: environment.site.admin + 'assets/silent-check-sso.html',
            },
        });
}
export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimations(),
        provideRouter(routes),
        {
            provide: KeycloakService,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeKeycloak,
            multi: true,
            deps: [KeycloakService],
        },
        provideHttpClient(withInterceptors([authInterceptor, loadingInterceptor])),
        MessageService,
        provideTranslateService({
            defaultLanguage: 'es',
        }),
        provideTranslateHttpLoader({
            prefix: './assets/i18n/',
            suffix: '.json',
        }),
    ],
};
